import { useEffect, useState } from 'react';

export default function MSA2026Page() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="w-full h-screen overflow-hidden bg-black flex items-center justify-center relative">
      <a
        href="https://icontracts.net"
        className="absolute top-4 left-4 z-10 px-4 py-2 rounded-md bg-white/10 hover:bg-white/20 text-white text-sm font-medium transition-all backdrop-blur-sm"
      >
        ← Home
      </a>

      <div className={`relative w-full h-full transition-all duration-1000 flex items-center justify-center ${isLoaded ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        <img
          src="/msa2026.jpg"
          alt="MSA 2026 Victory"
          className="max-w-full max-h-full object-contain"
        />
      </div>
    </div>
  );
}
